module.exports = ".detail-info-row {\n  border-bottom: 1px solid grey; }\n  .detail-info-row div:first-child {\n    font-weight: bold; }\n"